export type TagPathRoot = 'evfolyam' | 'intezmeny' | 'kompetencia' | 'tanar' | 'tantargy' | 'tevekenyseg';

export type TagTypes =
  | 'CONNECTION_DISCOVERY'
  | 'DESIGN_PROBLEM'
  | 'HYPOTHESIS_TESTING'
  | 'PRESENTATION'
  | 'PRODUCT_CREATION'
  | 'REFLECTION'
  | 'SYSTEMATIZATION';

export const ACTIVITY_TYPE_ICON_BASE_PATH = '/assets/kt/activity-icons/';

export const TOOL_TAG_PATH_PREFIX = 'tevekenyseg.eszkoz.' as const;

export const GRADE_TAG_PATH_PREFIX = 'evfolyam.' as const;

export const TYPE_TAG_PATH_PREFIX = 'tevekenyseg.tipus.' as const;

/** Parent ltree path for activity type category tags (`tevekenyseg.tipus`). */
export const TYPE_TAG_PARENT_PATH = 'tevekenyseg.tipus' as const;

/** Default query for loading type filter chips (direct children of the type parent). */
export const TYPE_FILTER_QUERY = { path: TYPE_TAG_PARENT_PATH, depth: 1 } as const;

/** Default query for loading subject tags in the NAT curriculum browser. */
export const SUBJECT_FILTER_QUERY = { path: 'tantargy' as const, depth: 1 } as const;

/** Default query for loading grade (évfolyam) tags (direct children of the grade root). */
export const GRADE_FILTER_QUERY = { path: 'evfolyam' as const, depth: 1 } as const;

export const WORKFORM_TAG_PATH_PREFIX = 'tevekenyseg.munkaforma.' as const;

/** Default query for loading workform (munkaforma) tags. */
export const WORKFORM_FILTER_QUERY = { path: 'tevekenyseg.munkaforma' as const, depth: 1 } as const;

export const SUBJECT_TAG_PATH_PREFIX = 'tantargy.' as const;

export const COMPETENCY_TAG_PATH_PREFIX = 'kompetencia.' as const;

export const TANAR_KOMMUNIKACIO_STILUS_TAG_PATH_PREFIX = 'tanar.kommunikacio.stilus.' as const;

/** Institution equipment/toolkit tags (`intezmeny.eszkoz.*`). */
export const INSTITUTION_TOOL_TAG_PATH_PREFIX = 'intezmeny.eszkoz.' as const;

/** Institution locations within the school (`intezmeny.helyszin.*`). */
export const INSTITUTION_LOCATION_TAG_PATH_PREFIX = 'intezmeny.helyszin.' as const;

/** Default query for loading school location tags. */
export const LOCATION_FILTER_QUERY = { path: 'intezmeny.helyszin' as const, depth: 1 } as const;

/** Nearby (off-site) locations (`intezmeny.kornyekbelihelyszin.*`). */
export const INSTITUTION_NEARBY_LOCATION_TAG_PATH_PREFIX = 'intezmeny.kornyekbelihelyszin.' as const;

/** Default query for loading activity tool tags. */
export const TOOL_FILTER_QUERY = { path: 'tevekenyseg.eszkoz' as const, depth: 1 } as const;

/** Default query for loading communication-style tags (direct children of the style root). */
export const STYLE_FILTER_QUERY = { path: 'tanar.kommunikacio.stilus' as const, depth: 1 } as const;

export const NARRATIVE_TAG_PATH_PREFIX = 'tevekenyseg.narrativa.' as const;

/** Default query for loading narrative (narratíva) tags. */
export const NARRATIVE_FILTER_QUERY = { path: 'tevekenyseg.narrativa' as const, depth: 1 } as const;

export const TAG_TYPE_PATHS: Record<string, TagTypes> = {
  /** KT-721 renamed category path; keep `felfedezo` for legacy stored tags. */
  'tevekenyseg.tipus.megfigyelo_vizsgalodo': 'CONNECTION_DISCOVERY',
  'tevekenyseg.tipus.felfedezo': 'CONNECTION_DISCOVERY',
  'tevekenyseg.tipus.kiserletezo': 'HYPOTHESIS_TESTING',
  'tevekenyseg.tipus.feldolgozo': 'SYSTEMATIZATION',
  'tevekenyseg.tipus.problemamegoldo': 'DESIGN_PROBLEM',
  'tevekenyseg.tipus.alkoto': 'PRODUCT_CREATION',
  'tevekenyseg.tipus.kommunikacios': 'PRESENTATION',
  'tevekenyseg.tipus.reflektiv': 'REFLECTION',
} as const;

export const COLORS_BY_TAG_TYPE: Record<TagTypes, string> = {
  CONNECTION_DISCOVERY: 'blue.500',
  HYPOTHESIS_TESTING: 'rose.500',
  SYSTEMATIZATION: 'green.500',
  DESIGN_PROBLEM: 'orange.500',
  PRODUCT_CREATION: 'purple.500',
  PRESENTATION: 'violet.500',
  REFLECTION: 'amber.500',
} as const;

export const COLORS_BY_TAG_PATH_ROOT: Record<TagPathRoot, string> = {
  tevekenyseg: 'purple.500',
  tantargy: 'blue.500',
  evfolyam: 'amber.500',
  kompetencia: 'purple.500',
  tanar: 'teal.500',
  intezmeny: 'green.500',
} as const;

export const DEFAULT_TAG_PATH_ROOT_COLOR = 'slate.500';
